/* CANIPANI — Carrousels à défilement natif
   Utilise scroll-snap : aucune dépendance, aucun calcul de position lourd.
   Les flèches ne s'affichent qu'au-delà de 990 px (cf. CSS). */

(function () {
  'use strict';

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var viewport = carousel.querySelector('[data-carousel-viewport]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!viewport || !prev || !next) return;

    function step() {
      var first = viewport.firstElementChild;
      if (!first) return viewport.clientWidth;
      var gap = parseFloat(getComputedStyle(viewport).columnGap || '16') || 16;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = viewport.scrollWidth - viewport.clientWidth - 2;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= max;
      var scrollable = viewport.scrollWidth > viewport.clientWidth + 4;
      carousel.querySelector('[data-carousel-nav]').hidden = !scrollable;
    }

    prev.addEventListener('click', function () { viewport.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { viewport.scrollBy({ left: step(), behavior: 'smooth' }); });
    viewport.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });
})();
